import { Loader2 } from './Icons';

interface LandingDataPlaceholderProps {
  label: string;
  className?: string;
  loading?: boolean;
  testId?: string;
}

export function LandingDataPlaceholder({
  label,
  className = '',
  loading = true,
  testId,
}: LandingDataPlaceholderProps) {
  return (
    <div
      data-testid={testId}
      className={`flex h-full items-center justify-center px-4 text-center ${className}`}
      role={loading ? 'status' : 'alert'}
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-4 text-[rgb(var(--theme-muted))]">
        {loading && (
          <Loader2
            className="h-8 w-8 animate-spin text-[rgb(var(--theme-primary-strong))] motion-reduce:animate-none"
            aria-hidden="true"
          />
        )}
        <p className="text-sm font-semibold sm:text-base">{label}</p>
      </div>
    </div>
  );
}
